import {
    externalLinkNodeHandler,
    internalLinkNodeHandler,
} from 'src/modules/dashboard/helpers/contentLinkNodeNavigateTo';
import { ContentLinkFragment } from '../documents/getHomeScreen.generated';
import { ColorScheme } from 'src/generated/webapp_gql';
import { captureException } from 'src/shared/helpers/captureException';

type TileContent = {
    title: string;
    image?: string | null;
    colorScheme?: ColorScheme | null;
    id: string;
    onClick: () => void;
};

export const mapContentLinkToTileProps = (link: ContentLinkFragment): TileContent | null => {
    switch (link.__typename) {
        case 'ExternalLinkNode':
            return {
                title: link.title,
                id: link.id,
                onClick: externalLinkNodeHandler(link),
            };
        case 'InternalLinkNode':
            return {
                title: link.title,
                image: link.image,
                colorScheme: link.colorScheme,
                id: link.id,
                onClick: internalLinkNodeHandler(link),
            };
        default:
            captureException(new Error('TileComponent does not support node type'), {
                nodeType: link.__typename,
            });
            return null;
    }
};
